<template>
  <v-btn
    :block="block"
    :class="[bgColor, textColor, textHover, bgHover, customClass]"
    class="shadow-sm"
    :size="buttonSize"
    :color="color"
    variant="flat"
  >
    <v-icon
      v-if="iconName"
      :size="iconSize"
      class="transition-none"
      :class="[iconMr]"
      >{{ iconName }}</v-icon
    >
    {{ text }}
  </v-btn>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HoverButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    textHover: {
      type: String,
      default: '',
    },
    bgHover: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    depressed: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    iconMr: {
      type: String,
      default: '',
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
    clickEvent: {
      type: String,
      default: '',
    },
  },
  computed: {
    buttonSize(): 'x-small' | 'small' | 'large' | 'default' | undefined {
      if (this.xSmall) return 'x-small'
      if (this.small) return 'small'
      if (this.large) return 'large'
      return undefined
    },
    iconSize(): 'small' | undefined {
      return this.smallIcon ? 'small' : undefined
    },
  },
})
</script>
